import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

// custome services
import { GlobleService } from 'src/app/core/services/globle.service';
import { AlertService } from 'src/app/core/services/alert/alert.service';

// custome enums
import { usersType } from 'src/app/core/enums/user/user-type';
import { LAYOUTS_TYPE } from 'src/app/core/enums/layouts/layouts-types';

@Injectable({
  providedIn: 'root'
})
export class ForcedStopGuard {

    constructor(
        private G: GlobleService,
        private Alert: AlertService,
    ) {}

    canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): boolean {
        
        // ES6 Destructing
        const { type } = this.G.userInfo || {};

        // check of user type
        if (type != usersType.normalUser) return true

        this.Alert.show({
            titleBtn: 'موافق',
            type: LAYOUTS_TYPE.alertFailure,
            callback: () => this.Alert.hide(),
            msg: `
                لا يمكن للمالك إضافة إعلان عقاري في الوقت الحالي تواصل مع الدعم الفني لتزويدك بالطريقة النظامية الصادرة من الهيئة العامة للعقار ليتم الإعلان عن عقارك بشكل نظامي.
                <br />
                في حالة كنت وسيط تواصل مع الدعم لتحويل حسابك إلى وسيط 
                <a class="main_color" href="https://wa.me/+966530107471" target="_blank"> من هنا </a>
            `
        })
        
        this.G.navigate(['/'])

        return false

    }
  
}
